const EmailDispositionEnum = Object.freeze({
    QUEUED: 'QUEUED',
    SENT: 'SENT',
    DELIVERED: 'DELIVERED',
    REJECTED: 'REJECTED',
    BOUNCED: 'BOUNCED',
    COMPLAINED: 'COMPLAINED',
    OPENED: 'OPENED',
    DELAYED: 'DELAYED'
});

export default EmailDispositionEnum;
